import { useEffect, useState } from 'react';
import { CSV } from '../../util/ExportFile';
import { Employee } from "../../model/Employee";
import { 
  DetailEmployeeModal, AddEmployeeModal, EditEmployeeModal,
  RenderTableKaryawan, fetchGetKaryawanAll,
} from '../../controller/dashboard/DataKaryawan';
import { 
  Users, 
  Plus, 
  Search, 
  Filter,
  ListOrdered,
  Calendar,
  User,
  Download,
  RotateCcw
} from 'lucide-react';

export default function DashboardDataKaryawan() {
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // bisa default 
  const [statusFilter, setStatusFilter] = useState('all');
  const [statusLength, setStatusLength] = useState('10');
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [employeeData, setEmployeeData] = useState<Employee[]>([]);
  const [selectedEmployee, setSelectedEmployee] = useState<Employee | null>(null);

  const filteredEmployees = employeeData.filter(emp => {
    const matchesSearch = emp.nama.toLowerCase().includes(searchTerm.toLowerCase()) || emp.nik.includes(searchTerm) ||emp.nama.includes(searchTerm);
    // const matchesStatus = statusFilter === 'all' || emp.status === statusFilter;
    return matchesSearch; 
    // && matchesStatus;
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentEmployees = filteredEmployees.slice(indexOfFirstItem, indexOfLastItem);
  let totalPages = itemsPerPage > 0 ? Math.ceil(filteredEmployees.length / itemsPerPage) : 0;
  const pageNumbers = totalPages > 0 ? Array.from({ length: totalPages }, (_, i) => i + 1) : [];

  const initDataKaryawan = async () => { 
    setLoading(true);
    try {
      const res = await fetchGetKaryawanAll();
      if (res.status === 200) {
        setEmployeeData(res.data); // pastikan API kirim data array karyawan
      } else {
        setEmployeeData([]);
      }
    } catch (error) {
      console.error(error);
      setEmployeeData([]);
    } finally {
      setLoading(false);
    }
  }

  const handleShowDetail = (karyawan: Employee) => {
    setSelectedEmployee(karyawan);
    setShowDetailModal(true);
  };

  const handleEditDetail = (karyawan: Employee) => {
    setSelectedEmployee(karyawan);
    setShowEditModal(true);
  };

  let countFetch = 0;

  useEffect(() => {
    // if(countFetch < 3){  countFetch += 1;}
    initDataKaryawan();
    setItemsPerPage(Number(statusLength === 'all' ? employeeData.length : statusLength))
  }, [employeeData, statusLength, totalPages]);

  return (
    <>
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-6">
        <div className="max-w-8xl mx-auto">
          {/* Header */}
          <div className="mb-8">
            <div className="flex items-center mb-4">
              <Users className="w-8 h-8 text-blue-600 mr-3" />
              <div>
                <h1 className="text-3xl font-bold text-gray-800">Pendataan Karyawan</h1>
              </div>
            </div>
          </div>

          {/* Controls */}
          <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
              <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
                {/* Search */}
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                  <input
                    type="text"
                    placeholder="Cari nama atau NIK..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full md:w-64"
                  />
                </div>

                {/* Filter */}
                <div className="relative">
                  <Filter className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                  <select
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    className="pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full md:w-48"
                  >
                    <option value="all">Semua Status</option>
                    <option value="organic">Karyawan Tetap</option>
                    <option value="kontrak">Kontrak</option>
                  </select>
                </div>

                {/* Length*/}
                <div className="relative">
                  <ListOrdered className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                  <select
                    value={statusLength}
                    onChange={(e) => {setStatusLength(e.target.value); setItemsPerPage(Number(e.target.value === 'all' ? employeeData.length : e.target.value))}}
                    className="pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full md:w-48"
                  >
                    <option value="10">10</option>
                    <option value="50">50</option>
                    <option value="100">100</option> 
                    <option value="500">500</option>
                    <option value="all">Tampil Semua</option>
                  </select>
                </div>
              </div>

              <div className="flex space-x-3">
                <button 
                  onClick={initDataKaryawan}
                  disabled={loading}
                  className="flex items-center px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors">
                  <RotateCcw className={`w-4 h-4 mr-2 ${loading ? "animate-spin" : ""}`} />
                  {loading ? "Memuat..." : "Muat Ulang"}
                </button>

                <button 
                  onClick={() => { CSV(employeeData, "Export_Karyawan") }}
                  className="flex items-center px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors">
                  <Download className="w-4 h-4 mr-2" />
                  Export
                </button>
                <button
                  onClick={() => { setShowAddModal(true); }}
                  className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                >
                  <Plus className="w-4 h-4 mr-2" />
                  Tambah Karyawan
                </button>
              </div>
            </div>
          </div>

          {/* Employee Table */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <div className="overflow-x-auto">
              <table className="min-w-full table-fixed divide-y divide-gray-200 text-center">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="w-1/4 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                      Nama
                    </th>
                    <th className="w-1/4 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                      NIK
                    </th>
                    <th className="w-1/4 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                      Status
                    </th>
                    <th className="w-1/4 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                      Aksi
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                    {
                      loading? 
                      <>
                        <tr>
                          <td colSpan={4} className="text-center py-4 text-gray-500">
                            Sedang Loading . . .
                          </td>
                        </tr>
                      </>
                      :
                      <>
                        <RenderTableKaryawan filteredData={currentEmployees} onOpenDetail={handleShowDetail} onOpenEdit={handleEditDetail} onRemoveState={initDataKaryawan} />
                      </>
                    }
                </tbody>
              </table>
            </div>
          </div>

          {/* Pagination */}
          <div className="mt-6 flex items-center justify-between">
            <div className="text-sm text-gray-700">
              Menampilkan <span className="font-medium">{currentPage}</span> hingga{' '}
              <span className="font-medium">{statusLength === "all" ? employeeData.length : statusLength}</span> dari{' '}
              <span className="font-medium">{employeeData.length}</span> karyawan
            </div>
            <div className="flex space-x-2">
              <button 
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(prev => prev - 1)}
              className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
                Previous
              </button>
              
              { pageNumbers.map((page) =>( 
                <button 
                  key={page}
                  onClick={() => setCurrentPage(page)}
                  className={`px-3 py-1 rounded ${ currentPage === page ? "bg-blue-500 text-white" : "bg-gray-200" }`}>
                  {page}
                </button>
              ))}
              
              <button 
                disabled={currentPage === Math.ceil(filteredEmployees.length / itemsPerPage)}
                onClick={() => setCurrentPage(prev => prev + 1)}
                className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
                Next
              </button>
            </div>
          </div>
        </div>

        {/* Add Employee Modal */}
        {showAddModal && <AddEmployeeModal setShowAddModal={setShowAddModal} onPostState={initDataKaryawan}/>}

        {/* Detail Employee Modal */}
        {showDetailModal && <DetailEmployeeModal employeeDetail={selectedEmployee} stateShowModal={setShowDetailModal} />}

        {/* Detail Employee Modal */}
        {showEditModal && <EditEmployeeModal employeeDetail={selectedEmployee} stateShowModal={setShowEditModal} onEditState={initDataKaryawan}/>}
      </div>
    </>
  )
}
